<template>
   <div v-if="jobOrigin">
      <b-modal
         title="Job Exportieren"
         ok-title="schliessen"
         cancel-disabled
         v-model="modalJobExport.visible"
      >
         <b-textarea
            v-model="modalJobExport.job"
            rows="18"
            ref="ref_modalJobExportTextarea"
         ></b-textarea>
      </b-modal>
      <b-modal
         title="Job Importieren"
         ok-title="nicht importieren"
         cancel-disabled
         v-model="modalJobImportVisible"
      >
         <b>Achtung: Die job.id wird nicht mitkopiert oder überschrieben (von allen Jobs).</b>
         <b>Job.state wird auf 1 gesetzt</b>
         <b>"[OFF]" wird an den Jobnamen angehaengt.</b>
         <b-textarea
            v-model="modalJobImportJob"
            rows="18"
            ref="ref_modalJobImportTextarea"
         ></b-textarea>
      </b-modal>
      <b-modal
         title="Server Fehler"
         v-model="modalDeleteArgumentError"
         size="md"
         centered
         ok-only
         ><!-- modal -->
         <div>
            <p>Das Argument konnte nicht gelöscht werden.</p>
         </div>
      </b-modal>
      <b-modal
         title="Nee.."
         v-model="modalDeleteArgumentWithPendingChangesDialogue"
         size="md"
         centered
         ok-only
         ><!-- modal -->
         <div>
            <p>
               Sie dürfen in der Datenbank abgelegte Jobargumente erst löschen, wenn
               keine weiteren offene Änderungen bestehen. Bitte speichern oder
               verwerfen Sie die vorgenommen Änderungen, wonach Sie diesen Vorgang
               wiederholen können.
            </p>
         </div>
      </b-modal>
      <b-modal
         title="Achtung: unabgespeicherte Daten"
         v-model="modalCloseDialogueState"
         size="md"
         centered
         no-close-on-esc
         no-close-on-backdrop
         hide-header-close
         ><!-- modal -->
         <div>
            <p>
               Sie haben Änderungen vorgenommen, aber nicht abgespeichert. Sind Sie
               sich sicher, dass sie das Edit-Fenster schliessen wollen?
            </p>
         </div>
         <div slot="modal-footer" class="w-100">
            <b-button
               size="md"
               class="float-right mx-1"
               variant="danger"
               @click="modalCloseDialogue('confirm')"
               >verwerfen</b-button
            >
            <b-button
               size="md"
               class="float-right"
               @click="modalCloseDialogue('abort')"
               >beibehalten</b-button
            >
         </div>
      </b-modal>
         <!-- :title="jobMutant.id ? 'Job bearbeiten' : 'neuen Job erstellen'" -->
      <b-modal
         v-model="modalSuccessDialogue"
         centered
         no-close-on-esc
         no-close-on-backdrop
         hide-header-close
         ><!-- modal -->
         <div>
            <p>Der Job wurde erfolgreich abgespeichert.</p>
         </div>

         <div slot="modal-footer" class="w-100">
            <b-button
               size="md"
               class="float-right mx-1"
               variant="success"
               @click="
                  modalSuccessDialogue = false;
                  visible = false;
               "
               :disabled="queryInProgress || nukeInProgress !== false"
               >Editfenster schliessen</b-button
            >
            <b-button
               size="md"
               class="float-right mx-1"
               variant="primary"
               @click="modalSuccessDialogue = false"
               >nicht schliessen</b-button
            >
         </div>
      </b-modal>
      <b-modal
         title="Job bearbeiten"
         v-model="visible"
         :size="(isFullscreen) ? 'xl' :'md'"
         @blur="resetUrl()"
         no-close-on-esc
         no-close-on-backdrop
         hide-header-close
         body-class="pt-1"
         ><!-- modal -->
         <div slot="modal-header" class="d-flex align-items-center w-100">
            <h3 v-if="jobMutant.id" class="pl-3 pb-0 mb-0 mr-auto">Job bearbeiten</h3>
            <h3 v-else              class="pl-3 pb-0 mb-0 mr-auto">neuen Job erstellen</h3>
               <!-- b-button
                  :disabled="disableSaveButton"
                  size="md"
                  class="d-flex justify-content-end mx-1"
                  variant="primary"
                  @click="save()"
                  >
                  <span>speichern</span>
               </b-button -->
               <b-button-group class="d-flex justify-content-end mx-1">
                  <b-button
                     :disabled="disableSaveButton"
                     size="md"
                     variant="primary"
                     @click="save()"
                  >speichern</b-button>
                  <b-button
                     size="md"
                     variant="outline-secondary"
                     @click="modalJobImportVisible = true"
                  >import</b-button>
                  <b-button
                     size="md"
                     variant="outline-secondary"
                     @click="modalJobExport.open()"
                  >export</b-button>
               </b-button-group>
               <b-button
                  class="d-flex justify-content-end mx-1"
                  variant="secondary-outline"
                  @click="toggleFullscreen()"
                  ><!-- button -->
                  <span v-if="isFullscreen" class="icon icon-shrink" />
                  <span v-else              class="icon icon-enlarge"/>
               </b-button>
               <b-button
                  class="close ml-0 mr-1 pr-1"
                  :disabled="queryInProgress"
                  variant="outline-secondary"
                  @click="close()"
               >×</b-button>

         </div>
         <b-overlay
            id="overlay-background-dropdown"
            :show="queryInProgress"
            spinner-type="grow"
            rounded="lg"
            spinner-small
            ><!-- overlay -->
            <b-alert :show="jobChanged" variant="warning"
               >Sie haben unabgespeicherte Änderungen offen.</b-alert
            >
            <br v-if="jobChanged" />
            <b>Allgemein</b>

            <b-row class="my-2">
               <b-col class="pr-0">
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center">id:</label>
                     <div class="col-8 pl-0">
                        <b-input
                           size="sm"
                           class="mr-1 inputsf"
                           v-model="jobMutant.id"
                           @submit="handleSubmit"
                        />
                     </div>
                  </b-row>
               </b-col>
               <b-col> <b-row> <label class="control-label col-4 d-flex justify-content-center"></label> <div class="col-7 pl-0"> </div> </b-row> </b-col>
            </b-row>


            <b-row class="my-2">
               <b-col class="pr-0">
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center">Titel:</label>
                     <div class="col-8 pl-0">
                        <b-input
                           size="sm"
                           class="mr-1 inputsf"
                           v-model="jobMutant.name"
                           @submit="handleSubmit"
                        />
                     </div>
                  </b-row>
               </b-col>
               <b-col> <b-row> <label class="control-label col-4 d-flex justify-content-center"></label> <div class="col-7 pl-0"> </div> </b-row> </b-col>
            </b-row>

            <b-row class="my-2">
               <b-col class="pr-0">
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center">Beschreibung:</label>
                     <div class="col-8 pl-0">
                        <b-input
                           size="sm"
                           class="mr-1 inputsf"
                           v-model="jobMutant.description"
                           @submit="handleSubmit"
                        />
                     </div>
                  </b-row>
               </b-col>
               <b-col> <b-row> <label class="control-label col-4 d-flex justify-content-center"></label> <div class="col-7 pl-0"> </div> </b-row> </b-col>
            </b-row>

            <hr class="mt-0 mb-1" />
            <b>Aufrufe</b>

            <b-row class="my-2">
               <b-col class="pr-0">
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center">Class Name:</label>
                     <div class="col-8 pl-0">
                        <b-input
                           size="sm"
                           class="mr-1 inputsf"
                           v-model="jobMutant.className"
                           @submit="handleSubmit"
                        />
                     </div>
                  </b-row>
               </b-col>
               <b-col> <b-row> <label class="control-label col-4 d-flex justify-content-center"></label> <div class="col-7 pl-0"> </div> </b-row> </b-col>
            </b-row>

            <b-row class="my-2">
               <b-col class="pr-0">
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center">Job Typ:</label>
                     <div class="col-8 pl-0">
                        <b-input
                           size="sm"
                           class="mr-1 inputsf"
                           v-model="jobMutant.jobType"
                           @submit="handleSubmit"
                        />
                     </div>
                  </b-row>
               </b-col>
               <b-col>
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center">Priorität:</label>
                     <div class="col-7 pl-0">
                        <b-input
                           size="sm"
                           class="mr-1 inputsf"
                           v-model="jobMutant.priority"
                           @submit="handleSubmit"
                        />
                     </div>
                  </b-row>
               </b-col>
            </b-row>

            <hr class="mt-0 mb-1" />
            <b>Zeiten</b>
            <b-row class="my-2">
               <b-col class="pr-0">
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center">Ab:</label>
                     <div class="col-8 pl-0">
                        <b-input
                           id="input-mask-nextRun"
                           v-model="jobMutant.firstRun_humanReadable"
                           size="sm"
                           placeholder="DD.MM.YYYY hh:mm:ss"
                           :state="validateFirstRun_humanReadable"
                        ></b-input>
                     </div>
                  </b-row>
               </b-col>
               <b-col>
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center">Bis:</label>
                     <div class="col-7 pl-0">
                        <b-input
                           id="input-mask-nextRun"
                           v-model="jobMutant.lastRun_humanReadable"
                           size="sm"
                           placeholder="DD.MM.YYYY hh:mm:ss"
                           :state="validateNextRun_humanReadable"
                        ></b-input>
                     </div>
                  </b-row>
               </b-col>
            </b-row>
            <b-row class="my-2">
               <b-col class="pr-0">
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center pt-2">Alle:</label>
                     <div class="col-8 pl-0">
                        <b-row>
                        <b-col class="pr-0">
                           <b-input
                              size="sm"
                              class="mr-1 inputsf pr-0"
                              v-model="jobMutant.frequency"
                              @submit="handleSubmit"
                           />
                        </b-col>
                        <b-col>
                           <b-form-select
                              v-model="jobMutant.period"
                              :options="periodOptions"
                              size="sm"
                           />
                        </b-col>
                        </b-row>
                     </div>
                  </b-row>
               </b-col>
               <b-col>
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center pt-2">Next Run:</label>
                     <div class="col-7 pl-0">
                        <b-input
                           id="input-mask-nextRun"
                           v-model="jobMutant.nextRun_humanReadable"
                           size="sm"
                           placeholder="DD.MM.YYYY hh:mm:ss"
                           :state="validateNextRun_humanReadable"
                        ></b-input>
                     </div>
                  </b-row>
               </b-col>
            </b-row>

            <hr class="mt-0 mb-1" />
            <b>Status</b>
            <b-row class="my-2">
               <b-col class="pr-0">
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center pt-2">Status:</label>
                     <div class="col-8 pl-0">
                        <b-input
                           size="sm"
                           class="mr-1 inputsf pr-0"
                           v-model="jobMutant.currentState"
                        />
                     </div>
                  </b-row>
               </b-col>
               <b-col>
                  <b-row>
                     <label class="control-label col-4 d-flex justify-content-center pt-2">Rechner/Kern:</label>
                     <div class="col-7 pl-0">
                        <b-input
                           size="sm"
                           class="mr-1 inputsf"
                           disabled
                           v-model="jobMutant.currentNode"
                        />
                     </div>
                  </b-row>
               </b-col>
            </b-row>
            <hr class="mt-0 mb-3" />
            <b>Argumente</b>
            <div class="pr-3">
               <b-table
                  v-if="jobMutant.jobarguments.length > 0"
                  id="job-arguments"
                  :items="jobMutant.jobarguments"
                  :fields="jobArgumentFields"
                  small
                  ><!-- table -->
                  <template v-slot:cell(label)="jobArgument" class="col-3">
                     <b-input
                        size="sm"
                        v-if="jobArgument.item.id"
                        v-model="jobArgument.item.label"
                     />
                     <b-form v-else>
                        <b-form-input
                           size="sm"
                           v-model="jobArgument.item.label"
                           :state="0 != jobArgument.item.label.length"
                           @keypress.enter="(evt) => evt.preventDefault()"
                        />
                        <b-form-invalid-feedback
                           :state="0 != jobArgument.item.label.length"
                        >Titel darf nicht leer sein.</b-form-invalid-feedback>
                     </b-form>
                  </template>
                  <template v-slot:cell(argumentKey)="jobArgument" class="col-3">
                     <b-input
                        size="sm"
                        v-if="jobArgument.item.id"
                        v-model="jobArgument.item.argumentKey"
                     />
                     <b-form v-else>
                        <b-form-input
                           size="sm"
                           v-model="jobArgument.item.argumentKey"
                           @keypress.enter="(evt) => evt.preventDefault()"
                           :state="
                              checkIfEmpty(jobArgument.item.argumentKey) &&
                              checkDuplicateKey(jobArgument.item.argumentKey)
                           "
                        />
                        <!-- no, multiple feedbacks is NOT POSSIBLE (because bootstrap vue is garbage) -->
                        <b-form-invalid-feedback
                           v-if="0 != jobArgument.item.argumentKey.length"
                           :state="checkIfEmpty(jobArgument.item.argumentKey)"
                        >
                           <span v-if="!checkIfEmpty(jobArgument.item.argumentKey)"
                              >Key ist leer.</span
                           ><!-- this doesn't work. Logic is broken within boostrap vue -->
                           <span
                              v-else-if="!checkDuplicateKey(jobArgument.item.argumentKey)"
                              >Key existiert bereits.</span
                           >
                        </b-form-invalid-feedback>
                     </b-form>
                  </template>
                  <template v-slot:cell(argumentValue)="jobArgument" class="col-6">
                     <b-input
                        size="sm"
                        v-if="jobArgument.item.id"
                        v-model="jobArgument.item.argumentValue"
                        @keypress.enter="(evt) => evt.preventDefault()"
                     />
                     <b-form v-else>
                        <b-form-input
                           size="sm"
                           v-model="jobArgument.item.argumentValue"
                           @keypress.enter="(evt) => evt.preventDefault()"
                        ></b-form-input>
                     </b-form>
                  </template>
                  <template v-slot:cell(action)="jobArgument" class="col-1">
                     <b-button
                        :variant="jobArgument.item.id ? 'danger' : 'secondary'"
                        block
                        size="sm"
                        @click="nuke(jobArgument.item)"
                        :disabled="nukeInProgress !== false"
                        ><!-- button -->
                        <b-spinner
                           v-if="
                              nukeInProgress !== false &&
                              nukeInProgress === jobArgument.item.id
                           "
                           type="grow"
                           label="Loading..."
                           small
                        />
                        <span v-else class="icon icon-bin" />
                     </b-button>
                  </template>
               </b-table>
               <b-button
                  class="float-right mr-2"
                  size="sm"
                  variant="success"
                  @click="createEmptyJobArgument()"
                  :disabled="queryInProgress || nukeInProgress !== false"
                  ><!-- button -->
                  Argument hinzufügen
               </b-button>
            </div>
         </b-overlay>
         <div slot="modal-footer" class="w-100">
            <b-button-group class="float-right mx-1">
               <b-button
                  :disabled="disableSaveButton"
                  size="md"
                  variant="primary"
                  @click="save()"
                  ><!-- button -->
                  <span>speichern</span>
               </b-button>
               <b-button
                  size="md"
                  variant="outline-secondary"
                  @click="modalJobImportVisible = true"
                  ><!-- button -->
                  <span>import</span>
               </b-button>
               <b-button
                  size="md"
                  variant="outline-secondary"
                  @click="modalJobExport.open()"
                  ><!-- button -->
                  <span>export</span>
               </b-button>
            </b-button-group>
            <b-button
               :disabled="queryInProgress"
               size="md"
               class="float-right"
               @click="close()"
               ><!-- button -->
               <span v-if="jobChanged">verwerfen</span>
               <span v-else>schliessen</span>
            </b-button>
         </div>
      </b-modal>
   </div>
</template>
<style>
.inputsf {
   min-width: 70% !important;
}
.modal-xl {
   max-width: auto !important;
   min-width: 92% !important;
}
.modal-md {
   max-width: auto !important;
   min-width: 50% !important;
}
</style>
<script>
export default {
   props: [],
   data() {
      return {
         isFullscreen: false,
         jobArgumentFields: [
            { key: "label", label: "Titel", sortable: false, tdClass: "col-3" },
            { key: "argumentKey", label: "Key", sortable: false, tdClass: "col-3" },
            {
               key: "argumentValue",
               label: "Value",
               sortable: false,
               tdClass: "col-5"
            },
            { key: "action", label: "", sortable: false, tdClass: "col-1" }
         ],
         visible: false,
         modalCloseDialogueState: false,
         modalSuccessDialogue: false,
         modalDeleteArgumentWithPendingChangesDialogue: false,
         modalDeleteArgumentError: false,
         queryInProgress: false,
         periodOptions: [
            { value: 0, text: "Minuten" },
            { value: 1, text: "Stunden" },
            { value: 2, text: "Tage" },
            { value: 3, text: "Wochen" },
            { value: 4, text: "Monate" },
            { value: 5, text: "Jahre" },
         ],
         nukeInProgress: false,
         // "const" job against which we compare lJob
         jobOrigin: { id: "", jobarguments: [], name: "", description: "", className: "", packageName: "", jobType: "", preferedNode: "", priority: "", period: "", frequency: "", firstRun: "", nextRun: "", lastRun: "", allowedRunTimeStart: "", allowedRunTimeEnd: "", currentState: "", currentNode: "", currentStartTime: "", lastUpdateTime: "", lastUpdateUser: "", lastUpdateReason: "", },
         jobMutant: { id: "", jobarguments: [], name: "", description: "", className: "", packageName: "", jobType: "", preferedNode: "", priority: "", period: "", frequency: "", firstRun: "", nextRun: "", lastRun: "", allowedRunTimeStart: "", allowedRunTimeEnd: "", currentState: "", currentNode: "", currentStartTime: "", lastUpdateTime: "", lastUpdateUser: "", lastUpdateReason: "", },

         //job export import modals
         modalJobExport: {
            visible: null,
            job: null,
            global: this,
            submit() {
               console.log("modalJobExport.submit() TODO");
               //TODO
            },
            open() {
               this.job = JSON.stringify(this.global.jobMutant);
               this.visible = true;
               // shit doesn't work, don't know why.
               // this.global.$nextTick( function () {
               //    //this.global.$refs.ref_modalJobExportTextarea.focus();
               //    setTimeout(() => {this.global.$refs.ref_modalJobExportTextarea.focus();}, 1750);
               // });
            },
            close() {
               this.job = null;
               this.visible = false;
            },
            // test() { // this works fine.
            //    console.log("modalJobExport::test()");
            //    this.global.$refs.ref_modalJobExportTextarea.focus();
            // }
         },
         modalJobImportJob: "",
         modalJobImportVisible: false,
      };
   },
   watch: {
      visible: function(n) {
         if(n == true) {
            if(this.jobMutant && this.jobMutant.id) {
               window.history.pushState( "", "", `/jobschedule/${this.jobMutant.id}/edit`);
            }else{
               window.history.pushState( "", "", `/jobschedule/create`);
            }
         }
      },
      modalJobImportJob: function(n) {
         if((n != null) && (n.length != 0)) {
            try{
               const maybeId = this.jobMutant.id;
               this.jobMutant = JSON.parse(n);

               // strip all jobargument-ids
               for(let arg of this.jobMutant.jobarguments) {
                  arg.id = null;
                  // because we could be overwriting an existing job, we want
                  // to use that id (but usually this.jobMutant.id will be null).
                  arg.jobScheduleId = this.jobMutant.id;
               }
               // we overwrite the Id because it makes little sense to use the ID of the other job.
               this.jobMutant.id = maybeId;
               if( "[OFF]" !== this.jobMutant.name.substring(0, 5)) {
                  this.jobMutant.name = "[OFF] " + this.jobMutant.name;
                  this.$bvToast.toast( `[OFF] wurde an dem Jobnamen angehangen. Neuer Jobname: "${this.jobMutant.name}"`, {
                     title: "Job Schedule",
                     autoHideDelay: 5000,
                     appendToast: false,
                     variant: 'info',
                  });
               }

               switch(this.jobMutant.currentState)
               {
                  case 1:
                     /* DO NOTHING */
                     break;
                  case 0:
                     this.jobMutant.currentState = 1;
                     this.$bvToast.toast( 'ACTUNG: currentState wurde zur Sicherheit von "0" auf "1" geändert.', {
                        title: "Job Schedule",
                        autoHideDelay: 5000,
                        appendToast: false,
                        variant: 'info',
                     });
                     break;
                  default:
                     this.$bvToast.toast( `GEFAHR: currentState == ${this.jobMutant.currentState} und wird nicht verändert!`, {
                        title: "Job Schedule",
                        autoHideDelay: 15000,
                        appendToast: false,
                        variant: 'danger',
                     });
                     break;
               }

               this.modalJobImportJob = "";
               this.modalJobImportVisible = false;
               this.$bvToast.toast( `Job Erfolgreich importiert.`, {
                  title: "Job Schedule",
                  autoHideDelay: 500,
                  appendToast: false,
                  variant: 'success',
               });

            }catch(error) {
               this.$bvToast.toast( `Job konnte nicht importiert werden. Stellen Sie sicher,
                dass es sich um ein JSON formatierter String handelt,
                den Sie hier reinkopiert haben.`, {
                  title: "Job Schedule",
                  autoHideDelay: 1500,
                  appendToast: false,
                  variant: 'danger',
               });
               this.modalJobImportJob = "";
               this.modalJobImportVisible = false;
               console.error(error);
            }
         }
      }
   },
   computed: {
      countryOptions: function() {
         if (!this.countries) return [];
         return this.countries.map(function (c) {
            return { value: c.id, text: c.countryName };
         });
      },
      jobChanged: function() {
         // if success dialogue is being shown, we just updated the job and there are no pending changes.
         if (this.modalSuccessDialogue) return false;
         return !_.isEqual(this.jobMutant, this.jobOrigin);
      },
      validateFirstRun_humanReadable: function()
      {
         if(!this.jobMutant
         || !('firstRun_humanReadable' in this.jobMutant)
         ) return false;

         if(this.jobMutant.firstRun_humanReadable === ""
         || this.jobMutant.firstRun_humanReadable === null
         ) return true;

         return this.validateDateTime(this.jobMutant.firstRun_humanReadable);
      },
      validateLastRun_humanReadable: function()
      {
         if( !this.jobMutant
         || !('lastRun_humanReadable' in this.jobMutant)
         ) return false;

         if(("" === this.jobMutant.lastRun_humanReadable)
         || this.jobMutant.lastRun_humanReadable === null
         ) return true;

         return this.validateDateTime(this.jobMutant.lastRun_humanReadable);
      },
      validateNextRun_humanReadable: function()
      {
         if(!this.jobMutant
         || !('nextRun_humanReadable' in this.jobMutant)
         ) return false;

         if( ""  === this.jobMutant.nextRun_humanReadable
         || null === this.jobMutant.nextRun_humanReadable
         ) return true;

         return this.validateDateTime(this.jobMutant.nextRun_humanReadable);
      },
      disableSaveButton: function() {
         for (const jobargument of this.jobMutant.jobarguments) {
            if ( !this.checkIfEmpty(jobargument.label)
              || !this.checkIfEmpty(jobargument.argumentKey)
              // !this.checkIfEmpty(jobargument.argumentValue)
              || !this.checkDuplicateKey(jobargument.argumentKey)
              || !this.validateFirstRun_humanReadable
              || !this.validateNextRun_humanReadable
            ) return true;
         }
         return this.queryInProgress || !this.jobChanged;
      }
   },
   methods: {
      resetUrl() {
         window.history.pushState("", "", '/jobschedule');
      },
      toggleFullscreen() {
         this.isFullscreen = !this.isFullscreen;
      },
      validateDateTime(dateTime) {
         if(!dateTime) return false;
         const [date, time] = dateTime.split(" ");
         if(!this.validateDate(...date.split(".")/*.reverse()*/)) return false;
         return this.validateTime(time);
      },
      validateDate(day, month, year) {
         if((year === null)
         || (year === "")
         || (!Number.isInteger(Number(year))
         || (year < 1970)
         || (year > 2049)
         )) return false;
         if((month === null)
         || (month === "")
         || (!Number.isInteger(Number(month))
         || (month < 1)
         || (month > 12)
         )) return false;
         if((day === null)
         || (day === "")
         || (!Number.isInteger(Number(day))
         || (day < 1)
         || (day > 31)
         )) return false;
         return true;
      },
      validateTime(time) {
         const [hour, minute, second] = time.split(':');
         if((hour === null)
         || (hour === "")
         || (!Number.isInteger(Number(hour))
         || (hour > 24)
         || (hour < 0)
         )) return false;
         if((minute === null)
         || (minute === "")
         || (!Number.isInteger(Number(minute))
         || (minute > 60)
         || (minute < 0)
         )) return false;
         if((second === null)
         || (second === "")
         || (!Number.isInteger(Number(second))
         || (second > 60)
         || (second < 0)
         )) return false;
         return true;
      },
      //notice how these two methods together create a nice bijection between data repr. and hr repr.
      unixDateToHumanReadable(unix) {
         // 2007-05-20 15:13:00 => ...
         //return moment(date).format("DD.MM.YYYY HH:mm:ss"); //don't know why this isn't working.
         try{
            const [date, time]           = unix.split(' ');
            const [year, month, day]     = date.split("-");
            const [hour, minute, second] = time.split(':');
            return `${day}.${month}.${year} ${hour}:${minute}:${second}`;
         }catch(error) {
            return "";
         }
      },
      humanReadableToUnixDate(hr) {
         // 20.05.2007 15:13:00 => ...
         const [date, time]           =   hr.split(' ');
         const [day, month, year]     = date.split(".");
         const [hour, minute, second] = time.split(':');
         return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      },

      checkIfEmpty(key) {
         let ret = key.length != 0;
         return ret;
      },
      checkDuplicateKey(key) {
         if (!key) return true;
         let count = 0;
         for (const jobArgument of this.jobMutant.jobarguments)
            if (key === jobArgument.argumentKey) ++count;
         return 1 === count;
      },
      createEmptyJobArgument() {
         this.jobMutant.jobarguments.push({
            id: null,
            label: "",
            description: "",
            argumentKey: "",
            argumentValue: "",
            jobScheduleId: this.jobMutant.id,
            lastUpdateTime: "",
            lastUpdateUser: "",
            lastUpdateReason: "",
         });
      },
      modalCloseDialogue(choice) {
         if ("confirm" === choice) {
            this.jobMutant = _.cloneDeep(this.jobOrigin); //can this fail?
            this.resetUrl();
            this.visible = false;
         } else if ("abort" == choice) {
            //do nothing
         }
         this.modalCloseDialogueState = false;
      },
      handleSubmit(evt) {
         evt.preventDefault();
      },
      nuke(jobArgument) {
         if (!jobArgument.id) {
            for (let k = 0; k < this.jobMutant.jobarguments.length; ++k) {
               //this.jobMutant.jobarguments.splice(this.jobMutant.jobarguments.findIndex( x => _.isEqual(x, jobArgument) ), 1);//why this no workk?
               if (_.isEqual(this.jobMutant.jobarguments[k], jobArgument)) {
                  this.jobMutant.jobarguments.splice(k, 1);
                  k = 9999999;
               }
            }
         } else {
            // check if there are open changes, if so, abort nuke.
            if (this.jobChanged) {
               this.modalDeleteArgumentWithPendingChangesDialogue = true;
               return;
            }
            this.nukeInProgress = jobArgument.id;
            Promise.all([
               axios.get(`/jobschedule/argument/delete/${jobArgument.id}`),
               new Promise((r) => setTimeout(r, 750)),
            ])
               .then(([response]) => {
                  this.nukeInProgress = false;
                  if (response.data == "success") {
                     this.jobMutant.jobarguments.splice(
                        this.jobMutant.jobarguments.findIndex(
                           (x) => x.id === jobArgument.id
                        ),
                        1
                     );
                     this.jobOrigin.jobarguments.splice(
                        this.jobOrigin.jobarguments.findIndex(
                           (x) => x.id === jobArgument.id
                        ),
                        1
                     );
                     this.$emit("mutatedJob", this.jobMutant);
                  } else {
                     this.modalDeleteArgumentError = true;
                  }
               })
               .catch((error) => {
                  this.nukeInProgress = false;
                  this.modalDeleteArgumentError = true;
                  console.error(error);
               });
         }
      },
      save() {
         if (this.jobChanged) {
            this.queryInProgress = true;

            //convert HumanReadable mirror members to normal members.
            if(!this.jobMutant.firstRun_humanReadable) {
               this.jobMutant.firstRun = null;
            }else{
               this.jobMutant.firstRun = this.humanReadableToUnixDate( this.jobMutant.firstRun_humanReadable );
            }
            if(!this.jobMutant.lastRun_humanReadable) {
               this.jobMutant.lastRun = null;
            }else{
               this.jobMutant.lastRun = this.humanReadableToUnixDate( this.jobMutant.lastRun_humanReadable );
            }

            if(!this.jobMutant.nextRun_humanReadable) {
               this.jobMutant.nextRun = null;
            }else{
               this.jobMutant.nextRun = this.humanReadableToUnixDate( this.jobMutant.nextRun_humanReadable );
            }

            if( "" === this.jobMutant.argumentValue ) this.jobMutant.argumentValue = null;
            axios.post( "/jobschedule/save", {
                  payload: JSON.stringify(this.jobMutant),
               })
               .then((response) => {
                  this.queryInProgress = false;
                  this.open(response.data);
                  this.modalSuccessDialogue = true;
                  this.$emit("mutatedJob", this.jobMutant);
               })
               .catch((error) => {
                  this.queryInProgress = false;
                  alert("Speichervorgang ist fehlgeschlagen.");
                  console.error(error);
               });
         }
      },
      open(origin) {
         if(!('jobarguments' in origin)  // !Object.keys(origin).includes("jobarguments")
         || !origin.jobarguments
         ) origin.jobarguments = [];

         origin.firstRun_humanReadable = this.unixDateToHumanReadable(origin.firstRun);
         origin.lastRun_humanReadable  = this.unixDateToHumanReadable(origin.lastRun );
         origin.nextRun_humanReadable  = this.unixDateToHumanReadable(origin.nextRun );

         this.jobOrigin = _.cloneDeep(origin);
         this.jobMutant = _.cloneDeep(origin);
         this.visible = true;
      },
      close() {
         if (this.jobChanged) {
            this.modalCloseDialogueState = true;
         } else {
            this.resetUrl();
            this.visible = false;
         }
      },
   },
   created() {
      this.jobMutant = this.jobOrigin;
   },
   mounted: function() {
      this.$nextTick( function () {
         window.addEventListener( 'keyup', event => {
            if(event.altKey && event.keyCode === 78 && this.visible)
            {
               if(!this.jobMutant.jobarguments.find( x => (x.id == null) && (x.argumentKey == "") )) {
                  // this.$refs.refInputQuery.focus();
                  this.createEmptyJobArgument();
               }else{
                  this.$bvToast.toast( "Fuellen sie die fehlenden ArgumentKeys aus.", {
                     title: "Job Schedule",
                     autoHideDelay: 1500,
                     appendToast: false,
                     variant: 'danger',
                  });
               }
            }
         })
      });
   }

};
</script>
